module.exports = __webpack_public_path__ + "static/media/linkedin.f17e1252.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/social-icons/linkedin.svg
// module id = 182
// module chunks = 0